import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FormViewService, SubmissionService } from '@xilo-mono/form-contracts';
import { changeInputCSS } from '../helper/form';

@Component({
  selector: 'xilo-mono-form-viewer-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['../../form-viewer.component.scss', './textarea.component.scss']
})

export class CustomTextareaComponent extends FieldType {
  isInvalid = false;
  errorMessage = false;
  changeInputCSS = changeInputCSS;

  constructor(
    public formViewService: FormViewService,
    private submissionService: SubmissionService,
    ) {
    super();
  }

  updateMetadata(event: Event) {
    const target = event.target as HTMLTextAreaElement;
    if (target?.value) {
      let { value } = target;
      if (typeof value === 'string') {
        try {
          value = target.value.trim();
        } catch (error) {
          value = target.value;
        }
        this.formControl.setValue(value);
      }
      
      if (Array.isArray(this.to.clientTag)) {
        this.to.clientTag.forEach((tag) => {
          this.submissionService.onUpdateMetadata({ key: tag, value }, this.field);
        });
      } else if (this.to.clientTag) {
        this.submissionService.onUpdateMetadata({ key: this.to.clientTag, value }, this.field);
      }
    }
  }
  
  getError() {
    return 'Invalid response';
  }
}
